// NOVAPAY-116-RC3-R3 — plain browser → Telegram conversion (no catalog bootstrap).
import { openExternalAction, STAGING_STORE_TELEGRAM_URL } from "./external-link-v2.js";
import { STORE_INFO } from "./store-info-v2.js";
import type { StoreV2Lang } from "./store-v2-locale.js";
import { t } from "./store-v2-ui-copy.js";
import { persistDirectBrowserContinueAllowed } from "./telegram-webapp-context-v2.js";
import type { StoreV2Theme } from "./theme-v2.js";
import { applyStoreV2Theme } from "./theme-v2.js";
import { useEffect } from "react";
import { StoreV2GlobalClose } from "./components.js";

function storeTelegramDeepLink(): string {
  try {
    const url = new URL(STAGING_STORE_TELEGRAM_URL);
    url.searchParams.set("startapp", "store-v2");
    const src = new URLSearchParams(window.location.search).get("utm_source");
    if (src && src.length <= 32 && /^[a-z0-9_-]+$/i.test(src)) {
      url.searchParams.set("utm_source", src);
    }
    return url.toString();
  } catch {
    return STAGING_STORE_TELEGRAM_URL;
  }
}

export function DirectBrowserEntry({
  lang,
  theme,
  onContinueInBrowser,
  onLangChange,
  onBrowserCloseFallback,
}: {
  lang: StoreV2Lang;
  theme: StoreV2Theme;
  onContinueInBrowser: () => void;
  onLangChange: (lang: StoreV2Lang) => void;
  onBrowserCloseFallback?: () => void;
}) {
  useEffect(() => {
    applyStoreV2Theme(theme);
  }, [theme]);

  const openTelegram = () => {
    void openExternalAction({ type: "telegram", value: storeTelegramDeepLink(), skipAnalytics: true });
  };

  const continueBrowser = () => {
    persistDirectBrowserContinueAllowed();
    onContinueInBrowser();
  };

  return (
    <div className="sv2-root sv2-root--direct-browser" data-testid="sv2-direct-browser-entry">
      <div className="sv2-header sv2-header--minimal">
        <div className="sv2-header-leading">
          <StoreV2GlobalClose
            lang={lang}
            routeClass="direct_browser"
            {...(onBrowserCloseFallback ? { onBrowserCloseFallback } : {})}
          />
        </div>
      </div>
      <div className="sv2-consent-card sv2-direct-browser-card">
        <div className="sv2-consent-emoji" aria-hidden="true">
          🍜
        </div>
        <h2 className="sv2-consent-title">{STORE_INFO.name}</h2>
        <p className="sv2-consent-tag">{lang === "en" ? "Taste Asia!" : STORE_INFO.slogan}</p>
        <p className="sv2-muted sv2-direct-browser-lead">
          {lang === "en"
            ? "AsiaStyle works best inside Telegram Mini App. Open the store there for checkout and payment."
            : "AsiaStyle найзручніший у Telegram Mini App. Відкрийте магазин там для оформлення та оплати."}
        </p>
        <button type="button" className="sv2-cta" data-testid="sv2-open-telegram-store" onClick={openTelegram}>
          {lang === "en" ? "Open store in Telegram" : "Відкрити магазин у Telegram"}
        </button>
        <button type="button" className="sv2-cta sv2-secondary" data-testid="sv2-continue-browser" onClick={continueBrowser}>
          {lang === "en" ? "Continue in browser" : "Продовжити в браузері"}
        </button>
        <div className="sv2-lang-switch sv2-consent-lang" role="group" aria-label={t(lang, "lang")}>
          <button
            type="button"
            className={`sv2-lang-btn${lang === "ua" ? " is-active" : ""}`}
            onClick={() => onLangChange("ua")}
          >
            UA
          </button>
          <button
            type="button"
            className={`sv2-lang-btn${lang === "en" ? " is-active" : ""}`}
            onClick={() => onLangChange("en")}
          >
            EN
          </button>
        </div>
      </div>
    </div>
  );
}
